module.exports = __webpack_public_path__ + "img/employment.83587562.png";